import SubordinateDetails from "./SubordinateDetails";
export default SubordinateDetails;
